export const environment = {
  name: 'production-app',
  production: true,
  staging: false,
  serviceWorker: true,
  apiUrl: 'https://api.briefd.io',
  uploadsApiUrl: 'https://uploads.autobrief.io',
  carpeakApiUrl: 'https://api.carpeak.io',
  briefdAppUrl: 'https://app.briefd.io',
  carpeakAppUrl: 'https://app.carpeak.io',
  carpeakAppStoreUrl: 'https://apps.apple.com/si/app/autobrief-companion/id6755765102',
  carpeakGooglePlayUrl: 'https://play.google.com/store/apps/details?id=io.briefd.companion',
  chromeExtensionUrl: 'https://chromewebstore.google.com/detail/quickentry/nkhajogmaiobipcelekkhoinpddddefn',
  edgeExtensionUrl: 'https://microsoftedge.microsoft.com/addons/detail/quickentry/ihfjejhfcbomefebnjcepognohapjhgi',
  chromeExtensionId: 'nkhajogmaiobipcelekkhoinpddddefn',
  edgeExtensionId: 'ihfjejhfcbomefebnjcepognohapjhgi',
  gtmID: 'GTM-KH5BQNX8',
  facebookTrackingID: '437843593839236',
  hotjarTrackingID: '1754688',
  navbarColor: '#2F6C5B',
  chatBot: {
    organizationId: "8d6c590c-ef2d-47b5-93d7-265e1d623dc8",
    template_id: "58d902af-7aa5-4db3-bdc2-f81c9c1048f8",
    integration_name: "manual_settings",
    product_name: "chatbot",
    enabled: false
  },
  version: '<date-commit>',
  kwToHpRatio: 1.36,
  showDoberAvtoAuthHeaderInSettings: false,
  product_fruits: {
    code: 'kLMSgJNkefsfvedp',
  },
  ssr: {
    port: 4002,
    process: 'briefd-production'
  },
  features: {
    routes: {
      demo: false,
    }
  },
  doberAvtoAdBaseUrl: 'https://doberavto.si/oglas/',
  njuskaloAdBaseUrl: 'https://www.njuskalo.hr/search/?keywords=',
  tradingHubBaseUrl: 'https://autobrief.odoo.com/',
  avtoNetAdBaseUrl: 'https://www.avto.net/',
  vapidKey: 'BIt3zHsH5Rn4drmXOIUjUXdARGq3gbxh79d7sRPneDWVjInVHvipb-0TYx35-7pv0DcymCIAsv-h9Hby-uwjHno',
  firebase: {
    apiKey: "AIzaSyChdS0Yfk3ICYDNhsYBXLU5H94kF_SIdpQ",
    authDomain: "autobrief-f872b.firebaseapp.com",
    projectId: "autobrief-f872b",
    storageBucket: "autobrief-f872b.firebasestorage.app",
    messagingSenderId: "602889319410",
    appId: "1:602889319410:web:49b287973fe550c8d7f16b"
  },
  crisp_website_id: '9b54d1af-bbf2-4b93-be43-dc4d43266cb7',
};
